import { Signature } from '../types/signature.ts';
import { StorageLocation } from '../types/storageLocation.ts';
import {
    ShiftChangeInventoryFormData,
    CrossCheckResult,
    ShouldBeInventory,
} from '../types/form/shiftChangeInventoryForm.ts';

interface ShiftChangeInventorySlice {
    shiftChangeInventoryFormData: ShiftChangeInventoryFormData;
    setShiftChangeInventoryFormData: (
        data: Partial<ShiftChangeInventoryFormData>
    ) => void;
    resetShiftChangeInventoryFormData: () => void;
}

const createShiftChangeInventorySlice = (set: any) => ({
    shiftChangeInventoryFormData: {
        signature: {} as Signature,
        doubleSignature: null,
        storageLocation: {} as StorageLocation,
        crossCheckResults: [] as CrossCheckResult[],
        shouldBeInventory: {
            storageLocation: {} as StorageLocation,
            inventory: [] as ShouldBeInventory['inventory'],
        },
        acceptSaldoMismatch: false,
    } as ShiftChangeInventoryFormData,

    setShiftChangeInventoryFormData: (
        data: Partial<ShiftChangeInventoryFormData>
    ) =>
        set((state) => ({
            shiftChangeInventoryFormData: {
                ...state.shiftChangeInventoryFormData,
                ...data,
                shouldBeInventory: {
                    ...state.shiftChangeInventoryFormData.shouldBeInventory,
                    ...data.shouldBeInventory,
                },
                crossCheckResults:
                    data.crossCheckResults ??
                    state.shiftChangeInventoryFormData.crossCheckResults,
            },
        })),

    resetShiftChangeInventoryFormData: () =>
        set({
            shiftChangeInventoryFormData: {
                signature: {} as Signature,
                doubleSignature: null,
                storageLocation: {} as StorageLocation,
                crossCheckResults: [] as CrossCheckResult[],
                shouldBeInventory: {
                    storageLocation: {} as StorageLocation,
                    inventory: [] as ShouldBeInventory['inventory'],
                },
                acceptSaldoMismatch: false,
            },
        }),
});

export { createShiftChangeInventorySlice };
export type { ShiftChangeInventorySlice, ShiftChangeInventoryFormData };
